import React from 'react';

import { navigation } from '@origin-digital/reporting-client';

import { IWizardStepConfig, IWizardProps, IWizardState } from './Wizard.types';
import { WizardContext } from './WizardContext';
import StepWizard from 'react-step-wizard';
import { WizardNav } from './WizardNav';
import { StepWrapper } from './StepWrapper';

export class Wizard extends React.Component<IWizardProps, IWizardState> {
  private _wizard: any;
  public static defaultProps = {
    initialStep: 1,
  };

  constructor(props) {
    super(props);
    this.state = {
      answers: props.answers || {},
      errors: [],
    };
  }

  public componentDidMount() {
    navigation('screen', {
      currentUri: window.location.href,
      friendlyUri: `originenergy:electricity-gas:plans:wizard:step${this.props.initialStep}`,
    });
  }

  public handleStepChange = ({ activeStep }) => {
    this.setState({ errors: [] });
    navigation('screen', {
      currentUri: window.location.href,
      friendlyUri: `originenergy:electricity-gas:plans:wizard:step${activeStep}`,
    });
  };

  public handleSaveAnswers = async (answers: object) => {
    const { onAnswersUpdated } = this.props;

    return new Promise<object>((resolve) => {
      const updatedAnswers = { ...this.state.answers, ...answers };
      let updatedErrors = [];
      this.validateAnswers(updatedAnswers)
        .catch(({ errors }) => {
          updatedErrors = errors;
        })
        .finally(() => {
          this.setState(
            {
              answers: updatedAnswers,
              errors: updatedErrors,
            },
            () => {
              resolve(updatedAnswers);
              if (onAnswersUpdated) {
                onAnswersUpdated(updatedAnswers);
              }
            },
          );
        });
    });
  };

  public validateAnswers = async (answers?: object) => {
    const stepIndex = this._wizard.state.activeStep;
    const { config } = this.props;

    const { validationSchema } = config.steps[stepIndex];
    if (validationSchema) {
      return validationSchema.validate(answers).catch((errorObject) => {
        this.setState({ errors: errorObject.errors });
        return Promise.reject(errorObject);
      });
    }

    return Promise.resolve();
  };

  public validate = async () => {
    return this.validateAnswers(this.state.answers);
  };

  public getContextValues() {
    const { config } = this.props;
    const { answers, errors } = this.state;

    return {
      answers,
      config,
      errors,
      saveAnswers: this.handleSaveAnswers,
      validate: this.validate,
    };
  }

  public render() {
    const { config, initialStep } = this.props;

    return (
      <WizardContext.Provider value={this.getContextValues()}>
        <StepWizard
          instance={(instance) => (this._wizard = instance)}
          initialStep={initialStep}
          isLazyMount
          nav={<WizardNav />}
          onStepChange={this.handleStepChange}
        >
          {config.steps.map((stepConfig: IWizardStepConfig, i) => {
            return <StepWrapper stepConfig={stepConfig} key={i} />;
          })}
        </StepWizard>
      </WizardContext.Provider>
    );
  }
}
